import script from './SbExperimentVariation.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"elementRef",staticClass:"v",on:{"&click":function($event){return _vm.handleInteraction.apply(null, arguments)},"&focus":function($event){return _vm.handleInteraction.apply(null, arguments)},"&focusin":function($event){return _vm.handleInteraction.apply(null, arguments)},"&touchstart":function($event){return _vm.handleInteraction.apply(null, arguments)},"&scroll":function($event){return _vm.handleInteraction.apply(null, arguments)},"&wheel":function($event){return _vm.handleInteraction.apply(null, arguments)},"&keydown":function($event){return _vm.handleInteraction.apply(null, arguments)}}},[_vm._t("variation")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
